import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M34.39 25a1.5 1.5 0 0 1 1.5-1.5H93a1.5 1.5 0 0 1 1.5 1.5v18a1.5 1.5 0 0 1-1.5 1.5H83a1.5 1.5 0 0 1 0-3h8.5v-15H37.39V43a1.5 1.5 0 0 1-3 0z"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M19.5 43a1.5 1.5 0 0 1 1.5-1.5h44a1.5 1.5 0 0 1 0 3H22.5v41h41V61a1.5 1.5 0 0 1 1.5-1.5h32a1.5 1.5 0 0 1 1.5 1.5v20a1.5 1.5 0 0 1-1.5 1.5H66.5V87a1.5 1.5 0 0 1-1.5 1.5H21a1.5 1.5 0 0 1-1.5-1.5zm47 36.5h29v-17h-29z"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M98 19v72c0 2.21-1.79 4-4 4H78c-2.2 0-4-1.79-4-4V19c0-2.21 1.8-4 4-4h16c2.21 0 4 1.79 4 4"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M78 16.5c-1.374 0-2.5 1.12-2.5 2.5v72c0 1.38 1.126 2.5 2.5 2.5h16c1.382 0 2.5-1.118 2.5-2.5V19c0-1.382-1.118-2.5-2.5-2.5zM72.5 19c0-3.04 2.474-5.5 5.5-5.5h16c3.038 0 5.5 2.462 5.5 5.5v72c0 3.038-2.462 5.5-5.5 5.5H78c-3.026 0-5.5-2.46-5.5-5.5z"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M49.251 102.789a1.5 1.5 0 0 1 0 2.122l-10 9.99a1.5 1.5 0 0 1-2.121-2.123l10-9.99a1.5 1.5 0 0 1 2.121.001"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M37.129 102.789a1.5 1.5 0 0 1 2.121-.001l10 9.99a1.5 1.5 0 0 1-2.12 2.123l-10-9.99a1.5 1.5 0 0 1-.001-2.122"
      clipRule="evenodd"
    />
    <path fill="#00D8D8" d="M63.69 99.51a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M29.13 9.35a1.5 1.5 0 0 1 1.5 1.5v14.13a1.5 1.5 0 0 1-3 0V10.85a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M20.56 17.92a1.5 1.5 0 0 1 1.5-1.5h14.13a1.5 1.5 0 1 1 0 3H22.06a1.5 1.5 0 0 1-1.5-1.5M108.69 33.51a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M73.5 25a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 0 3h-8a1.5 1.5 0 0 1-1.5-1.5M73.5 35a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 0 3H75a1.5 1.5 0 0 1-1.5-1.5M73.5 45a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 0 3h-8a1.5 1.5 0 0 1-1.5-1.5M73.5 55a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 0 3H75a1.5 1.5 0 0 1-1.5-1.5M73.5 65a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 0 3h-8a1.5 1.5 0 0 1-1.5-1.5M73.5 75a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 0 3H75a1.5 1.5 0 0 1-1.5-1.5M73.5 85a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 0 3h-8a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconTakeoffBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconTakeoffBrand);
export default Memo;
